<script setup lang="ts">
import type { Component } from "vue";

defineProps<{
  icon?: Component;
  title: string;
}>();
</script>

<template>
  <div class="bg-primary-50 p-5 mb-5 last:mb-0">
    <div class="flex items-center font-semibold text-xl gap-2 mb-4">
      <component v-if="icon" :is="icon" class="w-5 h-5 text-primary" />
      <span>{{ title }}</span>
    </div>

    <slot></slot>
  </div>
</template>
